import { Route, Routes, Link } from 'react-router-dom';
import PaymentEntries from '../../pages/NewFigma/PaymentEntries.jsx';
import { PaymentPage } from './pages/PaymentReceiptPage';

function ManagePayments() {
  return (
    <>
      <Link to={'Payments'}>List</Link>
      <Link to={'Payment/CREATE/2'}>CREATE</Link>
      <Link to={'Payment/EDIT/12'}>EDIT</Link>
      <Link to={'Payment/VIEW/122'}>View</Link>

      <Routes>
        <Route path="/Payments" element={<PaymentEntries />} />
        <Route path="/Payment/:mode/:id" element={<PaymentPage  />} />
        <Route path="*" element={<PaymentEntries />} />
      </Routes>
    </>
  );
}

export { ManagePayments };
